module.exports = __webpack_public_path__ + "img/quit.be2fc7bd.svg";